/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import buildChecklistProgress from '@/redux/selectors/pieveSelectors/lib/buildChecklistProgress.js';
import buildWorkflowStepsById from '@/redux/selectors/pieveSelectors/lib/buildWorkflowStepsById.js';
import { activeThreadDraftWorkflow } from '@/redux/selectors/pieveSelectors/composerResolutionSelectors.js';
import { activeThreadChecklistState } from '@/redux/selectors/pieveSelectors/threadActivitySelectors.js';

// The active draft's steps by id. Read by every workflow tool row in the chat, which name the step a call
// touches.
export const activeThreadWorkflowStepsById = createSelector([activeThreadDraftWorkflow], (draft) => {
  return buildWorkflowStepsById(draft?.definition?.steps);
});

// Where the active checklist stands — "step 4 of 7" on the chat group label. Null when the thread has no
// checklist.
export const activeThreadChecklistProgress = createSelector([activeThreadChecklistState], (checklistState) => {
  return buildChecklistProgress(checklistState.checklist);
});
